import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

export default function DropdownMenu(props) {
    const { editDashboardClicked, deleteDashboardClicked } = props;
    const [anchorElement, setAnchorElement] = React.useState(null);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    const handleEditClicked = (e) => {
        editDashboardClicked();
        handleClose();
    };

    const handleDeleteClicked = (e) => {
        deleteDashboardClicked();
        handleClose();
    };

    return (
        <div>
            <Button
                color='primary'
                size='small'
                aria-controls='simple-menu'
                aria-haspopup='true'
                onClick={handleClick}
                startIcon={<FormatListBulletedIcon/>}
            >
                More Actions
            </Button>
            <Menu id='dropdown-menu' anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)} onClose={handleClose}>
                <MenuItem onClick={handleEditClicked}>Edit Dashboard</MenuItem>
                <MenuItem onClick={handleDeleteClicked}>Delete Dashboard</MenuItem>
            </Menu>
        </div>
    );
}
